import React from 'react'
import style from './Empresas.module.css'

import imagen1 from '../../../utils/images/logos/1-Jumbo-400x400px.png'
import imagen2 from '../../../utils/images/logos/3-Spid-400x400px.png'
import imagen3 from '../../../utils/images/logos/4-Vea-400x400px.png'
import imagen4 from '../../../utils/images/logos/5-Disco-400x400px.png'
import imagen5 from '../../../utils/images/logos/12-Easy-400x400px.png'
import imagen6 from '../../../utils/images/logos/15-Blaisten-400x400px.png'
import imagen7 from '../../../utils/images/logos/18-ShoppingC-400x400px.png'

import imagen8 from '../../../utils/images/logos/8-Gbarbosa-400x400px.png'
import imagen9 from '../../../utils/images/logos/9-Mercantil-400x400px.png'
import imagen10 from '../../../utils/images/logos/10-Bretas-400x400px.png'
import imagen11 from '../../../utils/images/logos/10-Perini-400x400px.png'
import imagen12 from '../../../utils/images/logos/11-Prezunic-400x400px.png'
import imagen13 from '../../../utils/images/logos/7-Giga-400x400px.png'

import imagen14 from '../../../utils/images/logos/Andreu-rojo.png'
import imagen15 from '../../../utils/images/logos/bw-group.jpg'
import imagen16 from '../../../utils/images/logos/ConectarIgualdad.png'
import imagen17 from '../../../utils/images/logos/dynamic.png'
import imagen18 from '../../../utils/images/logos/gottert.png'
import imagen19 from '../../../utils/images/logos/globant.png'
import imagen20 from '../../../utils/images/logos/Inmark.jpg'
import imagen21 from '../../../utils/images/logos/Inxpirius.png'
import imagen22 from '../../../utils/images/logos/iupix.png'
import imagen23 from '../../../utils/images/logos/LogoConcreta.png'
import imagen24 from '../../../utils/images/logos/LogoGrafmaq.png'
import imagen25 from '../../../utils/images/logos/LogoPiana.png'
import imagen26 from '../../../utils/images/logos/Procrear_Bicentenario_Argentina_84d7e_450x450.png'
import imagen27 from '../../../utils/images/logos/progresar.png'
import imagen28 from '../../../utils/images/logos/Second Skin.png'
import imagen29 from '../../../utils/images/logos/zaxera.png'
import imagen30 from '../../../utils/images/logos/zetti.png'


const Empresas = () => {
  return (
  <div className={style.container}>
    <a href="https://www.jumbo.com.ar/" target="_blank" rel="noopener noreferrer" aria-label="Ir a Jumbo">
      <img className={style.imagen} src={imagen1} alt="Logo Jumbo" />
    </a>

    <a href="https://www.cencosud.com/unidades-de-negocios" target="_blank" rel="noopener noreferrer" aria-label="Ir a Cencosud - Unidades de Negocios">
      <img className={style.imagen} src={imagen2} alt="Cencosud - Unidades de Negocios" />
    </a>

    <a href="https://supermercadosvea.com.ar/" target="_blank" rel="noopener noreferrer" aria-label="Ir a Supermercados Vea">
      <img className={style.imagen} src={imagen3} alt="Logo Supermercados Vea" />
    </a>

    <a href="https://www.disco.com.ar/" target="_blank" rel="noopener noreferrer" aria-label="Ir a Disco">
      <img className={style.imagen} src={imagen4} alt="Logo Disco" />
    </a>

    <a href="https://www.easy.com.ar/" target="_blank" rel="noopener noreferrer" aria-label="Ir a Easy">
      <img className={style.imagen} src={imagen5} alt="Logo Easy" />
    </a>

    <a href="https://www.blaisten.com.ar/" target="_blank" rel="noopener noreferrer" aria-label="Ir a Blaisten">
      <img className={style.imagen} src={imagen6} alt="Logo Blaisten" />
    </a>

    <a href="https://www.cencosudshoppingcenters.com/argentina/" target="_blank" rel="noopener noreferrer" aria-label="Ir a Cencosud Shopping Centers">
      <img className={style.imagen} src={imagen7} alt="Logo Cencosud Shopping Centers" />
    </a>


    <a href="https://www.gbarbosa.com.br/" target="_blank" rel="noopener noreferrer" aria-label="Ir a GBarbosa">
      <img className={style.imagen} src={imagen8} alt="Logo GBarbosa" />
    </a>

    <a href="https://www.mercantilatacado.com.br/" target="_blank" rel="noopener noreferrer" aria-label="Ir a Mercantil Atacado">
      <img className={style.imagen} src={imagen9} alt="Logo Mercantil Atacado" />
    </a>

    <a href="https://www.mercantilatacado.com.br/" target="_blank" rel="noopener noreferrer" aria-label="Ir a Mercantil Atacado">
      <img className={style.imagen} src={imagen10} alt="Logo Mercantil Atacado" />
    </a>

    <a href="https://www.perini.com.br/" target="_blank" rel="noopener noreferrer" aria-label="Ir a Perini">
      <img className={style.imagen} src={imagen11} alt="Logo Perini" />
    </a>

    <a href="https://www.prezunic.com.br/" target="_blank" rel="noopener noreferrer" aria-label="Ir a Prezunic">
      <img className={style.imagen} src={imagen12} alt="Logo Prezunic" />
    </a>

    <a href="https://www.giga.com.vc/" target="_blank" rel="noopener noreferrer" aria-label="Ir a Giga Atacado">
      <img className={style.imagen} src={imagen13} alt="Logo Giga Atacado" />
    </a>   

    <a href="https://andreu.com.ar/" target="_blank" rel="noopener noreferrer" aria-label="Ir a Andreu Transportes">
      <img className={style.imagen} src={imagen14} alt="Logo Andreu" />
    </a>       

    <a href="http://www.bywgroup.com/index.php" target="_blank" rel="noopener noreferrer" aria-label="Ir a ByW Group">
      <img className={style.imagen} src={imagen15} alt="Logo ByW Group" />
    </a>

    <a href="https://www.argentina.gob.ar/educacion/aprender-conectados/conectar-igualdad" target="_blank" rel="noopener noreferrer" aria-label="Ir a Conectar Igualdad">
      <img className={style.imagen} src={imagen16} alt="Conectar Igualdad" />
    </a>

    <a href="https://www.dynamic-solutions.com.ar/" target="_blank" rel="noopener noreferrer" aria-label="Ir a Dynamic Solutions">
      <img className={style.imagen} src={imagen17} alt="Logo Dynamic Solutions" />
    </a>

    <a href="https://www.gottert.com.ar/" target="_blank" rel="noopener noreferrer" aria-label="Ir a Gottert">
      <img className={style.imagen} src={imagen18} alt="Logo Gottert" />
    </a>

    <a href="https://www.globant.com/" target="_blank" rel="noopener noreferrer" aria-label="Ir a Globant">
      <img className={style.imagen} src={imagen19} alt="Logo Globant" />
    </a>

    <a href="https://www.grupoinmark.com/" target="_blank" rel="noopener noreferrer" aria-label="Ir a Grupo Inmark">
      <img className={style.imagen} src={imagen20} alt="Logo Grupo Inmark" />
    </a>

    <a href="https://www.inxpirius.com/" target="_blank" rel="noopener noreferrer" aria-label="Ir a Inxpirius">
      <img className={style.imagen} src={imagen21} alt="Logo Inxpirius" />
    </a>

    <a href="https://iupix.com/wordpress/" target="_blank" rel="noopener noreferrer" aria-label="Ir a Iupix">
      <img className={style.imagen} src={imagen22} alt="Logo Iupix" />
    </a>

    {/* Botones sin link */}
    <button type="button" onClick={(e) => e.preventDefault()} className={style.fakeLinkButton} aria-label="Imagen 20">
      <img className={style.imagen} src={imagen23} alt="Logo Concreta Group" />
    </button>

    <button type="button" onClick={(e) => e.preventDefault()} className={style.fakeLinkButton} aria-label="Imagen 21">
      <img className={style.imagen} src={imagen24} alt="Logo Grafmaq" />
    </button>

    <a href="https://dpadesigners.com/" target="_blank" rel="noopener noreferrer" aria-label="Ir a DPA Designers">
      <img className={style.imagen} src={imagen25} alt="Logo DPA Designers" />
    </a>

    <a href="https://www.argentina.gob.ar/interior/procrear" target="_blank" rel="noopener noreferrer" aria-label="Ir a Procrear">
      <img className={style.imagen} src={imagen26} alt="Logo Procrear" />
    </a>

    <a href="https://www.argentina.gob.ar/becasprogresar" target="_blank" rel="noopener noreferrer" aria-label="Ir a Becas Progresar">
      <img className={style.imagen} src={imagen27} alt="Logo Becas Progresar" />
    </a>

    <a href="https://secondskin.com.ar/" target="_blank" rel="noopener noreferrer" aria-label="Ir a Second Skin">
      <img className={style.imagen} src={imagen28} alt="Logo Second Skin" />
    </a>

    <a href="http://www.zaxera.com/" target="_blank" rel="noopener noreferrer" aria-label="Ir a Zaxera">
      <img className={style.imagen} src={imagen29} alt="Logo Zaxera" />
    </a>

    <a href="https://zetti.com.ar/" target="_blank" rel="noopener noreferrer" aria-label="Ir a Zetti">
      <img className={style.imagen} src={imagen30} alt="Logo Zetti" />
    </a>
 
  </div>
  
)
}

export default Empresas